/* ######################################################################################################################## */
/* FUNCTION (RESPONSIVE IMAGES) ########################################################################################### */
/* ######################################################################################################################## */
function responsiveImg()
{
	return jQuery('.responsiveImg').each(function()
	{
		var jQthis    = jQuery('.responsiveImg'),
			jQthisImg = jQthis.find('img'),
			imgSrc;

		if (window.HTMLPictureElement)
		{
			imgSrc = jQthisImg.prop('currentSrc');
        }
		else
		{
			picturefill(
			{
				reevaluate : true
			});

			imgSrc = jQthisImg.attr('src');
        }

        if(imgSrc)
			jQthis.css('background-image', 'url(' + imgSrc + ')');
    });
}
